const ContaLayout = () => import(/* webpackChunkName: "conta-chunk" */ './layouts/ContaPage')
const EXTERNAL_CONTA_DOMAIN = 'https://beta.paineldocorretor.com.br'

export default [
    {
        path: '/conta',
        beforeEnter: to => {
            const targetUrl = `${EXTERNAL_CONTA_DOMAIN}${to.fullPath}`
            window.location.replace(targetUrl)
        },
        redirect: '/conta/perfil',
        component: ContaLayout,
        children: [
            {
                path: 'perfil',
                component: () => import(/* webpackChunkName: "conta-chunk" */ './components/conta-perfil')
            },
            {
                path: 'corretora',
                component: () => import(/* webpackChunkName: "conta-chunk" */ './components/conta-corretora'),
                meta: {
                    authorize: ['Administrador']
                }
            },
            {
                path: 'assinatura',
                component: () => import(/* webpackChunkName: "conta-chunk" */ './components/AssinaturaForm'),
                meta: {
                    authorize: ['Administrador']
                }
            },
            {
                path: 'usuarios',
                component: () => import(/* webpackChunkName: "conta-chunk" */ './components/usuario-page'),
                meta: {
                    authorize: ['Administrador']
                }
            },
            {
                path: 'equipes',
                component: () => import(/* webpackChunkName: "conta-chunk" */ './components/equipe-page'),
                meta: {
                    authorize: ['Administrador']
                }
            },
            {
                path: 'integracoes',
                component: () => import(/* webpackChunkName: "conta-chunk" */ './components/conta-integracao')
            },
            {
                path: '/preferencias/cotacao',
                component: () => import(/* webpackChunkName: "conta-chunk" */ './components/CotacaoPreferenciasPage'),
                meta: {
                    authorize: ['Administrador']
                }
            }
        ]
    }
]
